@layer design-system {
  .root {
    display: grid;
    column-gap: var(--grid-gap, 16px);
    width: 100%;
  }

  @for $i from 1 through 12 {
    .cols#{$i} {
      grid-template-columns: repeat(#{$i}, minmax(0, 1fr));
    }
  }

  .cell {
    min-width: 0;
  }

  .gapSm {
    column-gap: 4px;
  }

  .gapMd {
    column-gap: 8px;
  }

  .gapLg {
    column-gap: 12px;
  }

  .alignStart {
    align-items: flex-start;
  }

  .alignCenter {
    align-items: center;
  }

  .alignStretch {
    align-items: stretch;
  }
}
